
<template>
  <!-- 血压计列表 4G血压计 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
          <el-button
            type="warning"
            icon="el-icon-back"
            plain
            @click="back"
            >返回</el-button
          >
        <el-form-item style="margin-left:60px" label="测量人:">
          <el-select
              v-model="formInline.user"
              placeholder="请选择"
              clearable>
              <el-option key="1" label="爸爸" value="1"></el-option>
              <el-option key="2" label="妈妈" value="2"></el-option>
              <!-- 1爸爸，2妈妈 -->
            </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select
              v-model="formInline.ano"
              placeholder="请选择"
              clearable>
              <el-option key="0" label="正常" value="0"></el-option>
              <el-option key="1" label="不正常" value="1"></el-option>
              <!-- 1爸爸，2妈妈 -->
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table
          :data="list"
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="测量人"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.user==1?'爸爸':'妈妈' }}</span>
            </template>
          </el-table-column>
        
          <el-table-column
            label="血压(高压)"
            prop="sys"
            align="center">
          </el-table-column>
          <el-table-column
            label="血压(低压)"
            prop="dia"
            align="center">
          </el-table-column>
          <el-table-column
            label="脉搏"
            prop="pul"
            align="center">
          </el-table-column>
          <el-table-column
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.ano == 0?'正常':'异常' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="测量时间"
            prop="createdTime"
            align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  data() {
    return {
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceNo: "",
      loading:false,
      formInline:{
        user:null
      }
    };
  },
  methods: {
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    back(){
      bus.$emit('close_current_tags');
    },
    onSubmit(){
      this.pageNum = 1;
      this.getTableData();
    },
    // 生成血压计随机测量数据
generateBpMockData(deviceNo) {
  // 根据设备编号最后一位确定数据数量
  const dataCount = parseInt(deviceNo.substr(deviceNo.length - 1)) || 5; // 默认5条
  const mockData = [];
  
  // 血压正常范围参考值
  const normalSysRange = [90, 139]; // 正常高压范围
  const normalDiaRange = [60, 89];  // 正常低压范围
  const normalPulRange = [60, 100]; // 正常脉搏范围
  
  for (let i = 0; i < dataCount; i++) {
    // 随机选择测量人 (1:爸爸, 其他:妈妈)
    const user = Math.random() > 0.5 ? 1 : 0;
    
    // 随机生成是否异常 (20%概率异常)
    const isAbnormal = Math.random() > 0.8;
    
    // 生成血压值
    let sys, dia, pul;
    if (isAbnormal) {
      // 异常血压值
      sys = Math.random() > 0.5 
        ? Math.floor(Math.random() * 30) + 140 // 140-169
        : Math.floor(Math.random() * 30) + 60; // 60-89
      
      dia = Math.random() > 0.5 
        ? Math.floor(Math.random() * 20) + 90  // 90-109
        : Math.floor(Math.random() * 20) + 40; // 40-59
      
      // 异常脉搏
      pul = Math.random() > 0.5 
        ? Math.floor(Math.random() * 50) + 101 // 101-150
        : Math.floor(Math.random() * 30) + 30; // 30-59
    } else {
      // 正常血压值
      sys = Math.floor(Math.random() * (normalSysRange[1] - normalSysRange[0] + 1)) + normalSysRange[0];
      dia = Math.floor(Math.random() * (normalDiaRange[1] - normalDiaRange[0] + 1)) + normalDiaRange[0];
      pul = Math.floor(Math.random() * (normalPulRange[1] - normalPulRange[0] + 1)) + normalPulRange[0];
    }
    
    // 生成随机时间（过去30天内）
    const date = new Date();
    const randomDays = Math.floor(Math.random() * 30);
    date.setDate(date.getDate() - randomDays);
    date.setHours(Math.floor(Math.random() * 24));
    date.setMinutes(Math.floor(Math.random() * 60));
    date.setSeconds(Math.floor(Math.random() * 60));
    const formattedTime = date.toISOString().slice(0, 19).replace('T', ' ');
    
    mockData.push({
      id: i + 1,
      deviceNo: deviceNo,
      user: user,          // 1:爸爸, 0:妈妈
      sys: sys,            // 高压
      dia: dia,            // 低压
      pul: pul,            // 脉搏
      ano: isAbnormal ? 1 : 0, // 0:正常, 1:异常
      createdTime: formattedTime
    });
  }
  
  // 按时间倒序排列
  return mockData.sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime));
},

// 获取血压计表格数据
// getTableData() {
//   let param = {
//     pageNum: this.pageNum,
//     pageSize: this.pageSize,
//     deviceNo: this.deviceNo,
//     user: this.formInline.user,  // 测量人筛选
//     ano: this.formInline.ano     // 状态筛选
//   };
//   console.log('血压参数:', param);
//   this.loading = true;
//   // 生成并赋值血压计模拟数据
//   this.list = this.generateBpMockData(this.deviceNo);
//       this.totalDataNumber = this.list.length;
//   this.loading = false;
// },


    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.deviceNo,
        user: this.formInline.user,//角色
        ano: this.formInline.ano,//角色
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/press/queryDataListWithPage", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },
  mounted() {
    this.deviceNo = this.$route.query.deviceNo;
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
</style>